import React from 'react'
import styled from 'styled-components'
// import { RADOM_COLORS } from '../util/Constants'
import { AlertIcon } from '../icons/AlertIcon'

const ErrorContainer = styled.div`
  background-color: #FEE2E2; 
  border: 1px solid #F87171; 
  border-radius: 8px;
  padding: 12px 16px;
  max-width: 500px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
`

const IconWrapper = styled.div`
  margin-top: 2px;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const Title = styled.span`
  color: #B91C1C;
  font-weight: 700;
  font-size: 14px;
`

const Message = styled.span`
  color: #B91C1C;
  font-size: 13px;
  line-height: 1.4;
`

interface IProps {
  message?: string
}

export const VerificationRequirementError = ({ message }: IProps): React.ReactElement | null => {
  if (!message) return null

  return (
    <ErrorContainer>
      <IconWrapper>
        <AlertIcon/>
      </IconWrapper>
      <Content>
        <Title>Message from Radom Compliance</Title>
        <Message>&quot;{message}&quot;</Message>
      </Content>
    </ErrorContainer>
  )
}
